
import { Vue, Component, Watch } from 'vue-property-decorator';
import { AppNotification } from '@/store/main/state';
import { commitRemoveNotification } from '@/store/main/mutations';
import { readAllNotifications } from '@/store/main/getters';
import ToastContent from './ToastContent.vue';

@Component
export default class NotificationsManager extends Vue {
  private pendingToastIds: (string | number)[] = [];

  get allNotifications(): AppNotification[] {
    return readAllNotifications(this.$store);
  }

  @Watch('allNotifications')
  public onNotificationsChange(notifications: AppNotification[]) {
    for (const notification of notifications) {
      const timeout = notification.color === 'error' ? 60000
        : notification.color === 'success' ? 10000
          : 5000;
      const toastType = notification.color === 'success' ? 'success'
        : notification.color === 'error' ? 'error'
          : notification.color === 'warning' ? 'warning'
            : 'info';

      if (notification.color === 'error' || notification.color === 'success') {
        for (const id of this.pendingToastIds) {
          this.$toast.dismiss(id);
        }
        this.pendingToastIds = [];
      }

      const toastId = (this.$toast as any)[toastType](
        { component: ToastContent, props: { notification } },
        { timeout },
      );

      if (notification.showProgress) {
        this.pendingToastIds.push(toastId);
      }

      commitRemoveNotification(this.$store, notification);
    }
  }
}
